// extracted by mini-css-extract-plugin
export var boldText = "_61-4";
export var checkboxContainer = "_61-6";
export var closeIcon = "_61-i";
export var container = "_61-0";
export var drawer = "_61-8";
export var drawerContent = "_61-9";
export var extraSmallText = "_61-5";
export var fulfillmentGroupTable = "_61-e";
export var largeText = "_61-3";
export var loadingSpinnerContainer = "_61-j";
export var mediumText = "_61-2";
export var narrow = "_61-f";
export var notificationLink = "_61-l";
export var packageCheckIconContainer = "_61-7";
export var slideoutHeaderActions = "_61-g";
export var slideoutHeaderActionsShifted = "_61-h";
export var slideoutHeaderContainer = "_61-a";
export var slideoutModal = "_61-c";
export var stickyHeaderWrapper = "_61-b";
export var table = "_61-k";
export var tableContainer = "_61-d";
export var tertiaryText = "_61-1";